import React from 'react';
import {
  SignInForm,
  ForgotPasswordForm,
  PasswordForm,
  TwoFactorAuthForm,
} from '../../components/Forms/Auth';
import { ForgotPasswordSubmitted } from '../../components/Auth';
import { AuthView } from './Auth.types';

type AuthHandlers = {
  handleSignIn: (data: any) => Promise<void>;
  handleForgotPassword: () => void;
  handleForgotPasswordSubmit: (data: any) => Promise<void>;
  handleBackToSignIn: () => void;
  handleResetPasswordConfirmation: (code: string) => Promise<void>;
  handleResetPassword: (data: any) => Promise<void>;
  handleTwoFactorAuth: (code: string) => Promise<void>;
  handleFirstSignIn: (data: any) => Promise<void>;
  getTempEmail: () => string;
  setTempData: (email: string, token?: string) => void;
  hasValidSession: (view: AuthView) => boolean;
};

export const getAuthViewContent = (
  view: AuthView,
  handlers: AuthHandlers
): React.ReactNode => {
  switch (view) {
    case 'sign-in':
      return (
        <SignInForm
          onSubmit={handlers.handleSignIn}
          onForgotPassword={handlers.handleForgotPassword}
        />
      );

    case 'forgot-password':
      return (
        <ForgotPasswordForm
          onSubmit={handlers.handleForgotPasswordSubmit}
          onBackToSignIn={handlers.handleBackToSignIn}
        />
      );

    case 'confirm-reset-code':
      return (
        <TwoFactorAuthForm
          title="Confirmation code"
          buttonText="Confirm"
          onSubmit={handlers.handleResetPasswordConfirmation}
          onBackToSignIn={handlers.handleBackToSignIn}
        />
      );

    case 'forgot-password-submitted':
      return (
        <ForgotPasswordSubmitted
          email={handlers.getTempEmail()}
          onBackToSignIn={handlers.handleBackToSignIn}
        />
      );

    case 'reset-password':
      return (
        <PasswordForm
          title="Reset password"
          subtitle="Make up a new password for your account."
          buttonText="Update password"
          passwordPlaceholder="New Password"
          confirmPasswordPlaceholder="Confirm new password"
          onSubmit={handlers.handleResetPassword}
          onBackToSignIn={handlers.handleBackToSignIn}
        />
      );

    case 'two-factor-auth':
      return (
        <TwoFactorAuthForm
          onSubmit={handlers.handleTwoFactorAuth}
          onBackToSignIn={handlers.handleBackToSignIn}
        />
      );

    case 'first-sign-in':
      return (
        <PasswordForm
          title="Create Password"
          subtitle="Please create a password for your account."
          buttonText="Create password"
          passwordPlaceholder="Password"
          confirmPasswordPlaceholder="Confirm password"
          onSubmit={handlers.handleFirstSignIn}
        />
      );

    default:
      return null;
  }
};
